import { IconSettings } from '@tabler/icons-react';
import { Avatar, Box, Menu, Tooltip, ActionIcon } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserIdentity } from '../redux/slices/appSlice';
import classes from './Header.module.css';
import HuginnMark from '../riskManager/components/HuginnMark';

export function Header({ user, isAuthenticated, userRoles, userIsRiskManager, onLogout }) {
  // The deck puts the tenant beside the wordmark — "HUGINN  NordFin A/S". It is the one piece
  // of context that matters on every screen: which organisation am I looking at.
  const orgName = useSelector(selectUserIdentity)?.orgName;
  const navigate = useNavigate();

  return (
    <header className={classes.header}>
      <div className={classes.content}>
        {/* The landing page's lockup — two beaks then the name. The old PNGs are
            black-on-transparent and unusable on the navy bar. */}
        <button className={classes.edgeButton} aria-label="Home" onClick={() => navigate('/')}>
          <span className={classes.brand}>
            <HuginnMark size={24} />
            <span className={classes.wordmark}>Huginn</span>
          </span>
        </button>

        {/* No navigation here.
            The bar carried a second, DIFFERENT menu — /dashboard, /assessments, /agency —
            pointing into the legacy ServiceDesk tree while the sidebar pointed at RiskManager.
            Two menus disagreeing about where a page lives is worse than one menu, and the deck
            has none: wordmark, org, ⌘K, avatar. Navigation lives in the sidebar. */}
        <Box style={{ marginLeft: 18, flex: 1, minWidth: 0 }}>
          {orgName && <span className={classes.org}>{orgName}</span>}
        </Box>

        {/* Right edge: avatar menu */}
        {isAuthenticated && user && (
          <Menu>
            <Menu.Target>
              <Tooltip label={`Role: ${userRoles.join(', ') || 'User'}`}>
                {/* 32, not 44. The bar is 48 and clips what overflows it, so a 44px avatar had
                    two pixels of air above and below — enough that a focus ring or a half-pixel
                    of rounding took a slice off the bottom. 32 leaves eight either side, and it
                    sits better against the 24px mark at the other end: the person is not a bigger
                    thing on this bar than the product is. */}
                <ActionIcon variant="transparent" radius="xl" size={32} className={classes.edgeIcon}>
                  <Avatar src={user.picture} alt={user.name || 'User'} radius="xl" size={32} />
                </ActionIcon>
              </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item disabled>Hello, {user?.name || 'User'}</Menu.Item>
              <Menu.Divider />
              <Menu.Item leftSection={<IconSettings size={16} />} disabled>
                Settings
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item onClick={onLogout}>Logout</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </div>
    </header>
  );
}
